import React from "react";

import { Route, withRouter, Link } from "react-router-dom";
import Logo from "../../assets/img/logo.png";
import { useHistory } from "react-router-dom";
const Header = (props) => {
  const history = useHistory();
  return (
    <React.Fragment>
      {/* <!-- =========================
  //     Header Top Section
  // ============================== --> */}
      <section id="main-slider-section" className="main-hero-section2">
        <section
          id="wd-header"
          className="d-flex align-items-center mob-sticky d-lg-none"
        >
          <div className="container">
            <div className="row">
              {/* <!-- =========================
                    Mobile Menu 
                ============================== --> */}
              <div className="order-1 order-sm-1 col-4 col-sm-4 col-md-4 d-block d-lg-none">
                <div className="accordion-wrapper hide-sm-up">
                  <a href="#" className="mobile-open">
                    <i
                      className="fa fa-bars"
                      style={{ backgroundColor: "black" }}
                    ></i>
                  </a>
                  {/* <!--Mobile Menu start--> */}

                  <ul id="mobilemenu" className="accordion">
                    <li className="mob-logo">
                      <a href="/">
                        <img src={Logo} />
                      </a>
                    </li>
                    <li>
                      <a className="closeme" href="#">
                        <i className="fa fa-times"></i>
                      </a>
                    </li>

                    <li className="out-link">
                      <a className="" href="/">
                        Home
                      </a>
                    </li>
                    <li>
                      <Link
                        className="out-link"
                        onClick={() => history.push("/products")}
                      >
                        Mobile Phones
                      </Link>
                    </li>
                    <li>
                      <a className="out-link" href="/packages">
                        Mobile Packages
                      </a>
                    </li>
                    <li className="out-link">
                      <a className="" href="/compareProducts">
                        Compare Phones
                      </a>
                    </li>
                    <li className="out-link">
                      <a className="" href="/comparePackages">
                        Compare Packages
                      </a>
                    </li>
                  </ul>
                  {/* <!--Mobile Menu end--> */}
                </div>
              </div>
              {/* <!--Mobile menu end--> */}{" "}
              <div className="order-1 order-sm-2  col-4 col-sm-4 col-md-4 col-lg-1 col-xl-1 text-center">
                <div className="blrub-logo">
                  <a href=".">
                    <img src={Logo} />
                  </a>
                </div>
              </div>
              {/* <!-- =========================
                     Login and My Acount 
                ============================== --> */}
              <div className="order-3 order-sm-3 col-4 col-sm-4 col-md- col-lg-10 col-xl-10">
                {/* <!-- =========================
                         User Account Section
                    ============================== --> */}
                <div className="acc-header-wraper">
                  <div className="serch-wrapper" style={{ color: "black" }}>
                    <div className="search">
                      <input
                        className="search-input"
                        placeholder="Search"
                        type="text"
                      />
                      <a href="#">
                        <i className="fa fa-search"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--Row End--> */}
          </div>
          {/* <!--Container End--> */}
        </section>
        {/* <!--Section End--> */}
        <section id="main-menu" className="sticker-nav">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-4 col-md-2 col-lg-2">
                <div className="blrub-logo">
                  <a href=".">
                    <img src={Logo} />
                  </a>
                </div>
              </div>
              <div className="col-2 col-md-6 col-lg-9">
                <div className="menu-container wd-megamenu">
                  <div className="menu">
                    <ul className="wd-megamenu-ul">
                      <li>
                        <a
                          className="main-menu-list"
                          href="/"
                          style={{ color: "black" }}
                        >
                          <i className="fa fa-home" aria-hidden="true"></i> Home
                        </a>
                      </li>
                      <li>
                        <a
                          className="main-menu-list"
                          style={{ color: "black" }}
                          href="/products"
                        >
                          Mobile Phone <i aria-hidden="true"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          className="main-menu-list"
                          style={{ color: "black" }}
                          href="/packages"
                        >
                          Mobile Packages <i aria-hidden="true"></i>
                        </a>
                      </li>
                      <li>
                        <Link
                          className="main-menu-list"
                          style={{ color: "black" }}
                        >
                          Compare
                        </Link>
                        <ul className="single-dropdown">
                          <li>
                            <a href="/compareProducts">Compare Products</a>
                          </li>
                          <li>
                            <a href="/comparePackages">Compare Packages</a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a
                          href="/contactUs"
                          className="main-menu-list"
                          style={{ color: "black" }}
                        >
                          Contact
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-4 col-sm-4 col-md-8 col-lg-1 text-left">
                <div className="acc-header-wraper">
                  <div className="serch-wrapper">
                    <div className="search">
                      <input
                        className="search-input"
                        placeholder="Search"
                        type="text"
                      />
                      <a href="#">
                        <i
                          className="fa fa-search"
                          style={{ color: "black" }}
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </React.Fragment>
  );
};

export default Header;
